import { ThemeProvider } from "@mui/system";
// import { theme } from "./Customization/Theme";
import RootNavigator from "./Routes/RootNavigator";
import { Provider } from "react-redux";
import CustomSnackbarProvider from "./Hooks/useNotification/CustomSnackbarProvider";
import store, { useAppDispatch } from "./Store";
import { useAppSelector } from "./Store";
import { useAuthStore } from "./Store/Slices/AuthSlice";
import { createDynamicTheme } from "./Customization/DynamicTheme";
import { theme as defaultTheme } from "./Customization/Theme";
import { validateToken } from "./Utils/Utils";
import { useEffect, useState } from "react";
import { ThemeProvider as StyledThemeProvider } from "styled-components";
import { domainDetails } from "./Store/Slices/SubAccount/subaccount.selectors";
import { SubAccountActions } from "./Store/Slices/SubAccount/subaccount.actions";
import getPublicAssets from "./Services/s3bucket";
import useFavicon from "./Hooks/useFavicon";
import { ColorUtils } from "./Utils/ColorUtils";

validateToken();

const ThemedApp = () => {
  // const { primaryColor, secondaryColor } = useAppSelector((state) => state.theme);

  const dispatch = useAppDispatch();
  const domainDetailsData: any = useAppSelector(domainDetails);
  useFavicon();

  useEffect(() => {
    if (window.location.hostname !== process.env.REACT_APP_DOMAIN_NAME) {
      dispatch(
        SubAccountActions.getDomainDetails({
          domain: window.location.hostname,
        }) as any
      );
    }
  }, []);

  const { userConfig }: any = useAppSelector(useAuthStore);
  const accountType = userConfig?.payload?.reseller_details ?? "";
  const theme =
    !accountType &&
    window.location.hostname === process.env.REACT_APP_DOMAIN_NAME
      ? defaultTheme
      : createDynamicTheme(
          userConfig?.payload?.reseller_details?.primaryColor || "#075e54",
          userConfig?.payload?.reseller_details?.secondaryColor || "#075e54",
          userConfig?.payload?.reseller_details?.buttonHoverColor || "#128c7e"
        );
  return (
    <ThemeProvider theme={theme}>
      <StyledThemeProvider theme={theme}>
        <CustomSnackbarProvider>
          <RootNavigator />
        </CustomSnackbarProvider>
      </StyledThemeProvider>
    </ThemeProvider>
  );
};

export default ThemedApp;
